import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import ManageClinic from "./ManageClinic";
import { useCODData } from "../../context/CODDataContext";
import {
  useGetDashboardStatus,
  useSendDeviceId,
  useGetProfileStatus,
} from "../../hooks/useProvider";
import useToken from "../../hooks/useToken";

import { useEffect, useRef } from "react";
import useSound from "use-sound";

const MainMenuVideo = ({ providerData, clinicData, profileCompletionData }) => {
  const location = useLocation();
  const { token } = useToken();
  const { isWaiting, isSafWaiting, isSoNotComplete } = useCODData();
  const { mutate: senDeviceId } = useSendDeviceId();
  const { data: menuData } = useGetDashboardStatus();
  const showAlert =
    (isWaiting || isSafWaiting || isSoNotComplete) &&
    !location.pathname.includes("/consultations") &&
    !location.pathname.includes("/consultation");
      const hideMenu =
    location.pathname === "/scribe-service-details" ||
    location.pathname.startsWith("/scribe-service-details/") ||
    location.pathname === "/nurse/scribe-service-details" ||
    location.pathname.startsWith("/nurse/scribe-service-details/");

  const restrictedPaths = ["/consultations", "/consultation"];
  const shouldPlaySound =
    providerData?.internalProvider === true &&
    !restrictedPaths.some((path) => location.pathname.includes(path));

  const { data: profileCompletionDataa } = useGetProfileStatus(
    localStorage.getItem("userID"),
  );

  // Ref to store the previous state
  const previousStatusRef = useRef({});

  useEffect(() => {
    if (clinicData?.status === "SUCCESS" && clinicData?.clinicProvider) {
      localStorage?.setItem(
        "clinicId",
        clinicData?.clinicProvider[0]?.clinicId,
      );
    }
  }, [clinicData]);

  const [playEmergencyCare] = useSound(
    process.env.REACT_APP_ALERTU_NOTIFICATION,
    {
      volume: 0.9,
    },
  );
  const [playJingle] = useSound(process.env.REACT_APP_JINGLE_NOTIFICATION, {
    volume: 0.9,
  });

  useEffect(() => {
    if (!providerData?.internalProvider) return; // Ensure sound plays only for internalProvider

    const currentStatus = menuData?.agentDashboardMenuStatus || {};

    const playSounds = () => {
      if (!shouldPlaySound) return;

      // Play specific sound only if the count increased
      if (
        currentStatus.emergencyCareReq > 0 &&
        currentStatus.emergencyCareReq !==
          previousStatusRef.current.emergencyCareReq
      ) {
        playEmergencyCare();
      }

      // Update the previous status
      previousStatusRef.current = { ...currentStatus };
    };

    // Play sounds on state update
    playSounds();

    // Prevent the jingle logic if the path is restricted
    if (!shouldPlaySound) return;

    // Start the interval after the initial timeout
    const jingleInterval = setInterval(() => {
      if (currentStatus.emergencyCareReq > 0) {
        playJingle();
      }
    }, 37000);

    // Clear interval on unmount
    return () => clearInterval(jingleInterval);
  }, [
    menuData?.agentDashboardMenuStatus,
    location.pathname,
    shouldPlaySound,
    playEmergencyCare,
    playJingle,
    providerData?.internalProvider,
  ]);

  useEffect(() => {
    if (token) {
      const tokenObj = {
        deviceToken: token,
        deviceId: "1234",
        userId: providerData?.id,
        deviceType: "web",
      };

      senDeviceId(tokenObj);
    }
  }, [token, providerData?.id, senDeviceId]);

  return (
    <>
      {/* 
    <div>
      <div className="clinic-info">
  <p className="clinic-name">Jain Clinic</p>
  <p className="clinic-location">Bengaluru, Karnataka</p>
</div>
    </div> */}
      {/* {providerData?.person?.addresses?.[0]?.address3 && (
   
  <div className="clinic-info">
    <p className="clinic-name">
      {providerData?.person?.addresses?.[0]?.address3 || ""}
    </p>
    <p className="clinic-location">
      {providerData?.person?.addresses?.[0]?.city || ""}
      {providerData?.person?.addresses?.[0]?.city &&
        providerData?.person?.addresses?.[0]?.state
        ? `, `
        : ""}
      {providerData?.person?.addresses?.[0]?.state || ""}
    </p>
  </div>

      )} */}

      {!providerData?.isScribeEnabled &&
        providerData?.person?.addresses?.[0]?.address3 && (
          <div className="clinic-info">
            <p className="clinic-name">
              {providerData?.person?.addresses?.[0]?.address3 || ""}
            </p>

            <p className="clinic-location">
              {providerData?.person?.addresses?.[0]?.city || ""}
              {providerData?.person?.addresses?.[0]?.city &&
              providerData?.person?.addresses?.[0]?.state
                ? ", "
                : ""}
              {providerData?.person?.addresses?.[0]?.state || ""}
            </p>
          </div>
        )}
      {/* {profileCompletionData?.personalInfo &&
  profileCompletionData?.professionalInfo &&
  profileCompletionData?.serviceInfo &&
  profileCompletionData?.isWebAiSignUp && (
    <Link
      to="/video-review"
      className={
        location.pathname.includes("/video-review") ? "sidebar_active" : ""
      }
    >
      Home
    </Link>
  )} */}

      {/* {profileCompletionData?.personalInfo &&
        profileCompletionData?.professionalInfo &&
        profileCompletionData?.serviceInfo && (
          <>
            {providerData?.isScribeEnabled ? (
              <>
                <Link
                  to="/ai/scribe"
                  className={
                    location.pathname.includes("/ai/scribe")
                      ? "sidebar_active"
                      : ""
                  }
                >
                  <span>Scribe</span>
                </Link>
                <Link
                  to="/ai/intake"
                  className={
                    location.pathname.includes("/ai/intake")
                      ? "sidebar_active"
                      : ""
                  }
                >
                  Intake
                </Link>
              </>
            ) : (
              profileCompletionData?.personalInfo &&
              profileCompletionData?.professionalInfo &&
              profileCompletionData?.serviceInfo && (
                <Link
                  to="/ai/intake"
                  className={
                    location.pathname.includes("/ai/intake")
                      ? "sidebar_active"
                      : ""
                  }
                >
                  Home
                </Link>
              )
            )}
          </>
        )} */}

        {profileCompletionData?.personalInfo &&
  profileCompletionData?.professionalInfo &&
  profileCompletionData?.serviceInfo && (
    <>
      {providerData?.isScribeEnabled ? (
        <>
          {/* Scribe — always visible */}
          <Link
            to="/ai/scribe"
            className={
              location.pathname.includes("/ai/scribe") ||
              location.pathname.startsWith("/scribe-service-details")
                ? "sidebar_active"
                : ""
            }
          >
            <span>Scribe</span>
          </Link>

          {/* Intake — hidden on scribe details */}
          {!hideMenu && (
            <Link
              to="/ai/intake"
              className={
                location.pathname.includes("/ai/intake")
                  ? "sidebar_active"
                  : ""
              }
            >
              Intake
            </Link>
          )}
        </>
      ) : (
        <>
          {/* Home — hidden on scribe details */}
          {!hideMenu && (
            <Link
              to="/ai/intake"
              className={
                location.pathname.includes("/ai/intake")
                  ? "sidebar_active"
                  : ""
              }
            >
              Home
            </Link>
          )}
        </>
      )}
    </>
  )}

       {/* {clinicData?.clinicProvider?.length > 0 && (
        <ManageClinic providerData={providerData} clinicData={clinicData} />
      )}  */}

      {/* <Link to="/testing" className={location.pathname.includes("/testing")
 ? "sidebar_active" : ""}
>
 Test
</Link> */}
    </>
  );
};

export default MainMenuVideo;
